import SponsoredText from './SponsoredText';
export default SponsoredText;